import { render } from "./Footer.vue?vue&type=template&id=06b32a92&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=06b32a92&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src88616841/src/scan_material_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b32a92"]])

export default __exports__